// extracted by mini-css-extract-plugin
export default {"table_container":"style_table_container__H8F0C","gameStats":"style_gameStats__vR91I","button_container":"style_button_container__mkmwp"};